import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7d9b2402"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper-content"
};
const _hoisted_2 = {
  class: "revenue-evolution-content"
};
const _hoisted_3 = {
  class: "revenue-evolution-chart"
};
const _hoisted_4 = {
  class: "lastest-value"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dashed-line"
}, null, -1));
const _hoisted_6 = {
  class: "historical-value"
};
const _hoisted_7 = {
  class: "revenue-text"
};
const _hoisted_8 = {
  key: 0,
  class: "green"
};
const _hoisted_9 = {
  key: 0,
  class: "details"
};
const _hoisted_10 = {
  key: 1,
  class: "red"
};
const _hoisted_11 = {
  key: 0,
  class: "details"
};
const _hoisted_12 = {
  key: 2,
  class: "gray"
};
const _hoisted_13 = {
  key: 0,
  class: "details"
};
const _hoisted_14 = {
  class: "period"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RevenueEvolutionCandle = _resolveComponent("RevenueEvolutionCandle");
  const _component_currency_value = _resolveComponent("currency-value");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_RevenueEvolutionCandle, {
    data: $props.revenueData[0]?.[$props.value_key] ?? $data.defaultData[$props.value_key],
    maxValue: $options.maxValue,
    selected_period: $props.selected_period,
    isLastest: "",
    index: 0,
    onHoveringCandle: $options.hoveringCandle
  }, null, 8, ["data", "maxValue", "selected_period", "onHoveringCandle"])]), _hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.revenueData.slice(1, 14), (data, index) => {
    return _openBlock(), _createBlock(_component_RevenueEvolutionCandle, {
      data: data?.[$props.value_key],
      maxValue: $options.maxValue,
      selected_period: $props.selected_period,
      index: index + 1,
      onHoveringCandle: $options.hoveringCandle
    }, null, 8, ["data", "maxValue", "selected_period", "index", "onHoveringCandle"]);
  }), 256))])]), _createElementVNode("div", _hoisted_7, [$props.revenueData[0]?.[$props.value_key] ? (_openBlock(), _createElementBlock("div", _hoisted_8, [$props.revenueData[0]?.[$props.value_key] >= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, " +" + _toDisplayString(($props.revenueData[0]?.[$props.value_key] * 100).toFixed(0)) + "% ", 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $props.revenueData[0]?.[$props.value_key] ? (_openBlock(), _createElementBlock("div", _hoisted_10, [$props.revenueData[0]?.[$props.value_key] < 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(($props.revenueData[0]?.[$props.value_key] * 100).toFixed(0)) + "% ", 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !$props.revenueData[0]?.[$props.value_key] ? (_openBlock(), _createElementBlock("div", _hoisted_12, [!$props.revenueData[0]?.[$props.value_key] ? (_openBlock(), _createElementBlock("div", _hoisted_13, "-")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_currency_value, {
    class: "details",
    value: $props.revenueData[0]?.revenue,
    precision: "2"
  }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_14, _toDisplayString($props.revenueData[0]?.label), 1)]);
}